<template>
  <div class="step-wrap" :class="{ iframeFontLarge: isInPassport }">
    <div class="terms">
      <p class="mb-20">{{ languages.delTermsTitle }}</p>
      <p class="terms-title">{{ languages.delCondTitle }}</p>
      <div class="terms-detail mt-10">
        <p class="mb-10 account-delete-terms" v-html="languages.delCond1"></p>
        <p class="mb-10 account-delete-terms" v-html="languages.delCond2"></p>
        <p class="account-delete-terms" v-html="languages.delCond3"></p>
      </div>
      <p class="terms-title mt-10">{{ languages.delNoticeTitle }}</p>
      <div class="terms-detail mt-10 mb-10">
        <p class="mb-10 account-delete-terms" v-html="languages.delNotice1"></p>
        <p class="mb-10 account-delete-terms" v-html="languages.delNotice2"></p>
        <p class="mb-10 account-delete-terms" v-html="languages.delNotice3"></p>
        <p class="mb-10 account-delete-terms" v-html="languages.delNotice4"></p>
        <p class="account-delete-terms" v-html="languages.delNotice5"></p>
      </div>
    </div>
    <div class="fixed-bottom">
      <van-checkbox-group
        v-model="checkResult"
        :class="showAgreeTip ? 'errorAnimate' : false"
      >
        <van-checkbox name="one" shape="square">
          {{ languages.delFormConfirm1 }}</van-checkbox
        >
        <van-checkbox name="two" shape="square" class="mt-10 mb-10">
          {{ languages.delFormConfirm2 }}</van-checkbox
        >
        <van-checkbox name="three" shape="square">
          <span @click="handleClickPolicy" v-html="languages.delForm"></span>
        </van-checkbox>
      </van-checkbox-group>
      <div class="btn-wrap flex mb-60 mt-30">
        <van-button class="btn" block type="info" @click="prevStep">
          {{ languages.delPrevStep }}
        </van-button>
        <van-button class="btn" block type="info" @click="handleNextStep">
          {{ languages.delNextStep }}
        </van-button>
      </div>
    </div>
    <van-dialog
      v-model="showTip"
      :title="languages.cannotDeleteMsgTitle"
      width="90%"
      :confirmButtonText="languages.confirmText"
      :confirmButtonColor="mainColor"
      @confirm="jumpServiceHome"
      @close="jumpServiceHome"
      :closeOnClickOverlay="true"
    >
      <div class="tip-wrap">
        <p>{{ languages.cannotDeleteMsg1 }}</p>
        <p>{{ failTip }}</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { stepKey } from '@configs/officialSupport/accountDelete';
import { Dialog, Toast } from 'vant';
import accountDelete from '@mixins/officialSupport/accountDelete';
export default {
  name: 'AgreeTerms',
  mixins: [accountDelete],
  data() {
    return {
      checkResult: [],
      showAgreeTip: false,
      showTip: false,
      compKey: stepKey.agreeTerms,
      failTip: ''
    };
  },
  methods: {
    async checkCanDelete() {
      this.setOverlayVisible(true);
      const res = await this.submitAiOrder({
        ...this.getSubmitCommonParams(),
        is_kr_player: this.submitForm.isKr,
        is_us_player: this.submitForm.isUs,
        is_ios_check_mode: this.isIosReview || false
      });
      this.setOverlayVisible(false);
      if (res?.result === 1) {
        const {
          hasReported = false,
          hasUnPayOrder = false,
          hasUnhandledSupportOrder = false,
          hasSafetyEvent = false
        } = res?.data || {};
        this.updateSubmitForm({ hasSafetyEvent });
        const failTip = {
          hasReported: this.languages.cannotDeleteMsg4,
          hasUnPayOrder: this.languages.cannotDeleteMsg3,
          hasUnhandledSupportOrder: this.languages.cannotDeleteMsg2
        };
        if (hasReported || hasUnPayOrder || hasUnhandledSupportOrder) {
          this.failTip =
            failTip[
              hasReported
                ? 'hasReported'
                : hasUnPayOrder
                ? 'hasUnPayOrder'
                : 'hasUnhandledSupportOrder'
            ];
          this.showTip = true;
        } else {
          this.nextStep();
        }
      } else {
        Toast.fail(res?.data?.msg || '');
      }
    },
    async handleNextStep() {
      if (this.checkResult.length === 3) {
        await this.checkCanDelete();
      } else {
        this.showAgreeTip = true;
        setTimeout(() => {
          this.showAgreeTip = false;
        }, 500);
      }
    },
    handleClickPolicy(e) {
      if (e.target.tagName === 'A') {
        e.stopPropagation();
        this.jumpPolicy();
      }
    }
  },
  components: {
    Dialog
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialSupport/workTempForm.scss';
@import '@assets/scss/officialSupport/accountDelete.scss';
.terms {
  &-detail {
    padding: 5px;
    background-color: #ffffff;
    line-height: 22px;
    p {
      font-size: 14px;
    }
  }
}

.mt-20 {
  margin-top: 20px !important;
}
.iframeFontLarge {
  .terms-detail {
    p {
      font-size: 24px;
    }
  }
}
</style>

<style lang="scss">
.account-delete-link {
  color: #1989fa;
}
.account-delete-terms {
  span {
    color: red;
  }
}
</style>
